// Simple client-side stub for anchoring a hash (replace with backend integration)
// Returns a fake txId and explorer URL for demo purposes.

export async function anchorHash(hash) {
  // TODO: replace with real backend call to anchor to a blockchain / timestamping service
  const txId = `demo-${hash.slice(0, 8)}-${Date.now()}`;
  const url = `https://example-blockchain-explorer/tx/${encodeURIComponent(txId)}`;
  return { txId, url, network: 'demo' };
}
